import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import Banner from '@cpg-its/ads.containers.banner';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioMinistry } from '../model/clergy-bio-app-models';
import ClergyBioPositionItem from './clergy-bio-position-item';
import { YesNoIndicators } from '../../../global/models/api-model';
import { getClergyBioInstitutions } from '../../../global/ducks/clergy-bio-api';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { FormGroup } from '../../../global/components/layout/form-group';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { autocompleteStyles } from '../../../global/constants/theme/styles/components/autocomplete';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { formInputErrorStyles } from '../../../Global/constants/theme/styles/components/form-input-error-styles';


interface Props {
	settings: ClergyBioSettings;
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	employment: ClergyBioMinistry;
	defaultValue: ClergyBioMinistry;
	setList?: any;
	isStipe?: boolean;
	addPosition?: any;
	errors?: any
	hideDivider?: boolean;
}


function ClergyBioMinistryItem(props: Props) {
	const autocompleteClasses = autocompleteStyles();
	const { settings, arrayField, id, formikProps, setList, isStipe, employment, addPosition, defaultValue, errors, hideDivider } = props;
	const buttonClasses = buttonStyles();
	const formInputErrorStylesClasses = formInputErrorStyles();


	const remove = () => {
		if (defaultValue?.id) {
			const list = _.cloneDeep(formikProps?.values[arrayField]);
			const toDelete = { ...defaultValue };
			toDelete.deleted = YesNoIndicators.Yes;
			list[id] = toDelete;
			const copy = { ...formikProps?.values };
			copy[arrayField] = list;
			setList(copy);
		} else {
			const list = formikProps?.values[arrayField];
			list.splice(Number(id), 1);
			const copy = { ...formikProps?.values };
			copy[arrayField] = list;
			setList(copy);
		}
	};

	const dispatch = useDispatch();
	const [options, setOptions] = useState([]);


	const debounceSearch = _.debounce((e) => {
		dispatch(getClergyBioInstitutions(
			e?.target?.value,
			(data) => setOptions(data?.results),
		));
	}, 500);

	const onChange = (event) => {
		formikProps.setFieldValue(`${arrayField}.${id}.institutionParsed`, event?.target?.value);
		debounceSearch(event);
	};

	const onSelect = (value) => {
		formikProps.setFieldValue(`${arrayField}.${id}.institutionParsed`, `${value?.name} ${value?.location}`);
		formikProps.setFieldValue(`${arrayField}.${id}.institutionInfo`, value);
		setOptions([]);
	};


	if (employment?.deleted === YesNoIndicators.Yes) {
		return null;
	}

	return (
		<>
			{
				errors && errors?.blockError &&
				<ContentSpacer>
					<Banner
						banner={{
							type: 'error',
							label: <p><strong>{errors?.blockError?.map(e => e).join(', ')}</strong></p>,
						}}
					/>
				</ContentSpacer>
			}
			{
				(!employment?.positions || employment?.positions?.length === 0) &&
				<ContentSpacer>
					<div data-formdata={`${arrayField}-employment-${id}`}>
						<Banner
							banner={{
								type: 'error',
								label: <p><strong>{settings?.atLeastOnePositionMessage}</strong></p>,
							}}
						/>
					</div>
				</ContentSpacer>
			}
			<DividerSection dashedBorder={!hideDivider} removeDivider={hideDivider}>
				<FormGroup>
					{
						employment?.institutionInfo && employment?.id &&
						<div className='form-item'><h4>{`${employment?.institutionInfo?.name}, ${employment?.institutionInfo?.location}`}</h4></div>

					}

					{
						(!isStipe && !employment?.id) &&
						<div className={`form-item ${autocompleteClasses.autocompleteWrapper}`}>
							<FormField
								name={`${arrayField}.${id}.institutionParsed`}
								label={settings?.miscellaneousInstitutionLabel}
								component='input'
								touched={formikProps.touched}
								errors={formikProps.errors}
								onChange={(e) => onChange(e)}
								required
							/>
							{
									employment?.errors?.institutionInfo && !formikProps.values[arrayField][id]?.institutionInfo?.id &&
								<div>
									<div className={formInputErrorStylesClasses.errorArrow}></div>
									<div className={formInputErrorStylesClasses.errorMessage}>
										{employment?.errors?.institutionInfo[0]}
									</div>
								</div>
							}
							<div className='autocomplete-container'>
								<ul className='autocomplete-list'>
									{
										options?.map(a => {
											return <li className='autocomplete-list-item'><button className='un-button autocomplete-list-item-button' type='button' onClick={() => onSelect(a)} >{a?.name} {a?.location}</button></li>;
										})
									}
								</ul>
							</div>
						</div>
					}

					<FormField
						name={`${arrayField}.${id}.dateBegan`}
						label={settings?.employmentStartDateLabel}
						component='datePicker'
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
						autoWidth
						disabled={isStipe}

					/>
					<FormField
						name={`${arrayField}.${id}.dateEnded`}
						label={settings?.employmentEndDateLabel}
						component='datePicker'
						touched={formikProps.touched}
						errors={formikProps.errors}
						autoWidth
						disabled={isStipe}

					/>
					{
						employment?.positions?.map((p, idx) =>
							<ClergyBioPositionItem
								key={`${p.id}-${idx}`}
								arrayField='positions'
								settings={settings}
								id={idx?.toString()}
								parentArrayField={arrayField}
								parentArrayId={id}
								formikProps={formikProps}
								employment={employment}
								setList={setList}
								defaultValue={defaultValue?.positions[idx]}
								errors={p?.errors}
							/>)
					}
					{
						addPosition && <div className='form-item'><button className={buttonClasses.primaryButton} type='button' onClick={() => addPosition(arrayField, id, formikProps?.values)} >
							<svg className='icon' aria-hidden='true' focusable='false'>
								<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#plus-icon' />
							</svg>
							{settings?.addPositionButtonText}</button></div>
					}
					{
						!isStipe &&
						<div className='form-item'><button className={buttonClasses.secondaryButton} type='button' onClick={() => remove()} >
							<svg className='icon' aria-hidden='true' focusable='false'>
								<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#minus-icon' />
							</svg>
							{settings?.removeNonStipendiaryButtonText}</button></div>
					}
				</FormGroup>
			</DividerSection>
		</>
	);
}

ClergyBioMinistryItem.defaultProps = {
	setList: null,
	isStipe: false,
	addPosition: null,
	errors: null,
	hideDivider: false,
};
export default ClergyBioMinistryItem;